import React, { useEffect } from "react";
import Routes from "./Routes";
import { BrowserRouter } from "react-router-dom";
import "./animate.css";

import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </div>
  );
}

export default App;
